import React from 'react';
import NewFooter from '../Components/NewFooter';
import PortalButton from '../Components/PortalButton';
import Logo from '../Components/Logo/Logo';
import ForgotPasswordModal from '../Components/ResetPasswordModal';
import styles from './Layout.module.scss';
import LandingImg from '../../images/venza-landing-img.png';

type LayoutVariant = 'split' | 'centered';

interface LayoutProps {
	children?: React.ReactNode;
	variant?: LayoutVariant;
	showPortalBtn?: boolean;
	showResetPassModal?: boolean;
	setShowResetPassModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const content = {
	heading: 'Know your risks. Defend your data.',
	description: 'Empower next-level data security with the Venza System.'
};

const RightPanel = () => (
	<div className={styles.rightContainer}>
		<div className={styles.svgContainer}>
			{/* <Icon type="venzaLanding" /> */}
			<img src={LandingImg} alt='landing-img'/>
		</div>
		<div className={styles.contentContainer}>
			<h1 className={styles.heading}>{content.heading}</h1>
			<p className={styles.description}>{content.description}</p>
		</div>
	</div>
);

export default function NewAuthLayout({
	children,
	variant = 'split',
	showPortalBtn = false,
	showResetPassModal = false,
	setShowResetPassModal
}: LayoutProps) {
	return (
		<div className={`${styles.root} ${styles[variant]}`}>
			<div className={styles.mainContent}>
				{variant === 'split' && (
					<>
						<div className={styles.leftInner}>
							<div className={styles.leftContainer}>
								<div className={styles.logoWrap}>
									<Logo />
								</div>
								{children}
							</div>
						</div>
						<RightPanel />
					</>
				)}

				{variant === 'centered' && (
					<div className={styles.centeredContainer}>
						<div className={styles.logoWrap}>
							<Logo />
						</div>
						{children}
					</div>
				)}
			</div>
			<div className={styles.bottomBar}>
				{showPortalBtn && <PortalButton />}
				{setShowResetPassModal && (
					<>
						<ForgotPasswordModal
							visible={showResetPassModal}
							onCancel={() => setShowResetPassModal(false)}
						/>
					</>
				)}
				<NewFooter
					isAdminLogin={showPortalBtn}
					setShowResetPassword={setShowResetPassModal}
				/>
			</div>
		</div>
	);
}
